<app-loading-spinner
  *ngIf="!(this.assetsResponse); else mainSection"
>
</app-loading-spinner>

<ng-template #mainSection>
  <app-banner
    [image]="image"
    [bannerTitle]="bannerTitle"
    [additionalStyles]="{ height: '21vh' }"
    [bannerTextStyles]="{ left: '0vw', top:'7vw', 'margin-left':'7vw' }"
  ></app-banner>
  <section class="lower-section">
    <div class="row main-content-row">
      <div class="col-md-2 filter-section">
        <app-filter
          [filterData]="filterArray"
          [selectedFilters]="selectedFilters"
          [selectedFilterChips]="filterChips"
          [defaultFilters]="defaultFilters"
          (filterSelectEvent)="filterSelected($event)"
        ></app-filter>
      </div>
      <div class="col-md-10 asset-section">
        <div class="filter-chip-container" *ngIf="filterChips?.length">
          <span
            class="uil-chip-filled uil-chip-action filter-chip-filled"
            *ngFor="let item of filterChips"
          >
            <span class="uil-chip-titlearea no-trailing-icon">
              <span class="uil-chip-title filter-title">{{ item.value }}</span>
            </span>
            <span class="uil-chip-icon-area">
              <span
                class="uil-chip-close-icon filter-close-icon"
                (click)="removeFilter(item)"
              ></span>
            </span>
          </span>
          <span
            class="uil-chip-filled uil-chip-action clear-filter-chip-filled"
            *ngIf="filterChips?.length"
          >
            <span class="uil-chip-titlearea no-trailing-icon">
              <span
                class="uil-chip-title clear-filter-title"
                >Clear all filters</span
              >
            </span>
            <span class="uil-chip-icon-area">
              <span
                class="uil-chip-close-icon clear-filter-close-icon"
                data-toggle="modal"
                data-target="#clearFilterWarningModal"
              ></span>
            </span>
          </span>
        </div>
        <hr
          *ngIf="filterChips?.length"
          style="border-bottom: 2px solid #dddddd"
        />
        <div
          class="form-group search-row"
          [class.filter-m-t]="filterChips?.length"
        >
          <div class="search-box">
            <span class="search-icon"><i class="fa fa-search"></i></span
            ><input
              type="text"
              class="form-control search-input"
              placeholder="Search"
              (input)="setRouteParams()"
              [(ngModel)]="searchText" (keyup)="searchKeyUp()"
            />
            <div (click)="clearSearch()" class="search-clear" [hidden]="!showCloseicon || !searchText.length" >
            <span class="search-clear-icon"><i class="fa fa-times"></i></span>
            </div>
          </div>
        </div>
        <div class="row seacrh-result-sort-row">
          <div class="col-md-4 show-count"
          >
            <span
              class="showCount"
              *ngIf="
                (assetListCopy | filter: searchText)?.length;
                else noresultfound
              "
            >
              Showing {{ (assetListCopy | filter: searchText)?.length }} of
              {{ assetCount }} assets
            </span>

            <ng-template #noresultfound>
              <span class="showCount"> Showing 0 of
                {{ assetCount }} assets</span>
            </ng-template>
          </div>
          <div class="col-md-3"></div>

          <div class="col-md-5 sortby-container">
            <div class="sortby-text">Sort By:</div>
            <div appClickOutside class="sortby-dropdown" id="sortDropdown">
              <label class="dropdown">
                <div class="dd-button" (click)="openDropdown()">
                  {{ sortedBy.displayName }}
                </div>

                <!-- <input type="checkbox" class="dd-input" id="test" /> -->
                <ul class="dd-menu" id="ddMenu" [class.active]="isDropdownOpen">
                  <li
                    class="dd-menu-item"
                    *ngFor="let item of sortByDropdown"
                    (click)="onItemsChange(item)" 
                    [class.disabled]="sortedBy.displayName==item.displayName"
                  >
                    <span class="item-name">{{ item.displayName }}</span>
                  </li>
                </ul>
              </label>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="
        (assetListCopy | filter: searchText)?.length;
        else noAssetsFound
      ">
          <div
            class="col-md-4 asset-column"
            *ngFor="let data of assetListCopy | filter: searchText"
          >
            <app-asset-card
              [card]="data"
              [searchText]="searchText"
              (bookmarkEvent)="onBoookmarkClick($event)"
            ></app-asset-card>
            <div></div>
          </div>
        </div>
        <ng-template #noAssetsFound>
          <span style="display: block; text-align: center;"> No Assets Available</span>
        </ng-template>
      </div>
    </div>
  </section>
</ng-template>

<div
  class="modal fade"
  id="clearFilterWarningModal"
  role="dialog"
  aria-label="close"
  data-backdrop="static"
  style="display: none"
>
  <div class="modal-dialog">
    <div class="uil-dialog-card">
      <div class="uil-card-title-area">
        <div class="uil-card-title">Warning</div>
      </div>
      <div class="uil-card-text">
        This will result in loss of all the selected filters.
      </div>
      <div class="uil-dialog-button-area">
        <button type="button" class="uil-btn-flat" data-dismiss="modal">
          Cancel
        </button>
        <button
          type="button"
          class="uil-btn"
          data-dismiss="modal"
          (click)="clearAllFilter()"
        >
          Proceed
        </button>
      </div>
    </div>
  </div>
</div>
